import { validateTextString, validatePhoneNumber, validateWhitespace, removeExtraWhitespace, removeWhitespace } from "../../services/service-forms.js";
import { simulateDelayedResponse } from "../../services/service-some-api.js";

export default class CallMeUp {
  constructor(element) {
    this.el = element;
    this.form = this.el.querySelector("form");
    this.submitButton = this.form.querySelector("[type='submit']");
    this.iconButton = this.submitButton.querySelector("svg");
    this.nameInput = this.form.querySelector("[name='name']");
    this.phoneInput = this.form.querySelector("[name='phone-number']");
    this.consent = this.form.querySelector("[name='consent']");
    this.allInputs = this.form.querySelectorAll("input");
    this.receipt = this.el.querySelector(".receipt") || null;
    this.description = this.el.querySelector(".description") || null;
    this.responseErrorEl = this.el.querySelector(".response-error");
    this.spinner = this.el.querySelector(".spinner") || null;
    this.maxLength = this.nameInput.getAttribute("max-length");
    this.sendForm = this.sendForm.bind(this);
    this.displaySpinner = this.displaySpinner.bind(this);
    this.hideSpinner = this.hideSpinner.bind(this);
    this.init();
  }

  init() {
    this.allInputs.forEach((input) => {
      input.addEventListener("input", () => {
        if (this.validateName(this.nameInput.value) && validatePhoneNumber(removeWhitespace(this.phoneInput.value)) && this.consent.checked) {
          this.submitButton.disabled = false;
          this.iconButton.classList.add("group-hover:fill-white");
          this.iconButton.classList.add("dot-arrow-animation")
          this.submitButton.addEventListener("click", this.sendForm);
        } else {
          this.submitButton.disabled = true;
          this.iconButton.classList.remove("group-hover:fill-white");
          this.iconButton.classList.remove("dot-arrow-animation")
          this.submitButton.removeEventListener("click", this.sendForm);
        }
      });
    });

    this.nameInput.addEventListener("blur", () => {
      if (!this.validateName(this.nameInput.value)) {
        this.nameInput.nextElementSibling.classList.remove("hidden");
      }
    });
    this.nameInput.addEventListener("input", () => {
      if (this.validateName(this.nameInput.value)) {
        this.nameInput.nextElementSibling.classList.add("hidden");
      }
    });
    this.phoneInput.addEventListener("blur", () => {
      if (!validatePhoneNumber(removeWhitespace(this.phoneInput.value))) {
        this.phoneInput.nextElementSibling.classList.remove("hidden");
      }
    });
    this.phoneInput.addEventListener("input", () => {
      if (validatePhoneNumber(removeWhitespace(this.phoneInput.value))) {
        this.phoneInput.nextElementSibling.classList.add("hidden");
      }
    });
  }

  validateName(name) {
    if (!validateTextString(name, { maxLength: this.maxLength }) || !validateWhitespace(name)) {
      return false;
    }
    return true;
  }

  sendForm(e) {
    e.preventDefault();
    // Get form values
    const name = removeExtraWhitespace(this.nameInput.value);
    const phoneNumber = removeWhitespace(this.phoneInput.value);
    const consent = this.consent.checked;

    if (validatePhoneNumber(phoneNumber) && this.validateName(name) && consent) {

      this.displaySpinner();

      const url = ""; //TODO: Add url
      const data = {
        name: name,
        phoneNumber: phoneNumber,
        consent: consent,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(url, requestOptions) // To simulate a response change to -> simulateDelayedResponse({ message: 'test' }, 2000, true)
      .then((response) => {
          this.hideSpinner();
          this.form.reset();
          console.log("Form submitted", response);
          if (this.receipt) {
            if (this.description) {
              this.description.classList.add("hidden");
            }
            this.form.classList.add("hidden");
            this.receipt.classList.remove("hidden");
          }
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.hideSpinner();
          this.responseErrorEl.classList.remove("hidden");
        });
    }
  }

  displaySpinner() {
    if (this.spinner) {
      this.submitButton.style.visibility = "hidden";
      this.spinner.style.visibility = "visible";
    }
  }

  hideSpinner() {
    if (this.spinner) {
      this.submitButton.style.visibility = "visible";
      this.spinner.style.visibility = "hidden";
    }
  }
}
